import React from 'react';
import * as XLSX from 'xlsx';
import { gql } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import service from '../../services/graphQlServices';
import '../../index.css';
import { useRef } from 'react';
import '../../assets/scss/deliverables.scss';
import Modal from '../components/modals';
import Select from 'react-select';
import { ReactComponent as Cancel } from '../../assets/svg/cancel-icon.svg';
import { useNavigate } from 'react-router-dom';
import { requestExecutor } from '../../controllers/ApiFunctions';
import DatePicker from 'react-datepicker';
import '../../App.css';
import moment from 'moment';
import { addEmpAttHoursInXLSX, addHHMMTime, addTimes, formatEmpAttHours } from '../../utils/common';

const AttendanceFormatTable = ({ modalState, isModalOpen }) => {
	const getDepartmentAndWorkspaceQuery = gql`
		query EmployeeDefaultfilters {
			employeeDefaultfilters {
				department
				workspaceId
			}
		}
	`;
	const downloadAttendanceQuery = gql`
		query DownloadEmpAttendance($filters: DownloadEmpAttendanceFiltersInput) {
			downloadEmpAttendance(filters: $filters) {
				login
				logout
				totalHours
				status
				employeeId
				date
				fullName
				workspaceId
				department
			}
		}
	`;

	const params = useParams();
	const calRef = useRef();

	const currentDate = moment();
	const currentYear = currentDate.year();
	const currentMonth = currentDate.month() + 1;
	const startDate = parseInt(`${currentYear}${String(currentMonth).padStart(2, '0')}01`, 10);
	const endDate = parseInt(
		`${currentYear}${String(currentMonth).padStart(2, '0')}${moment(currentDate)
			.endOf('month')
			.format('DD')}`,
		10,
	);
	const [headers, setHeaders] = useState([]);
	const typeOfDays = ['Attendance State', 'IN', 'OUT', 'WH'];
	let groupedById;
	const summaryObj = {};

	const [data, setdata] = useState({
		workspaceOptions: [],
		departmentOptions: [],
		selectedworkspace: '',
		selectedDepartment: '',
		selectedMonth: new Date(),
		startDate: startDate,
		endDate: endDate,
	});
	const [loader, setLoader] = useState(false);
	const [downloadAttendance, setDownloadAttendance] = useState(false);

	const json = {
		filters: {
			startDate: data.startDate,
			endDate: data.endDate,
			workspaceId: data.selectedworkspace,
			...(data.selectedDepartment && { department: data.selectedDepartment }),
		},
	};

	const tableData = JSON.parse(localStorage.getItem('tableData')) || [];
	const [numberOfDays, setNumberOfDays] = useState(0);
	const [dateArray, setDateArray] = useState([]);
	function generateHeaders(month, year) {
		const daysInMonth = new Date(year, month, 0).getDate();
		setNumberOfDays(daysInMonth);
		const startDate = new Date(year, month - 1, 1);
		const startDay = startDate.getDay();

		const headers = ['S.N.', 'Staff Name', 'Department', 'Days'];
		const daysOfWeek = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

		let datesArray = [];
		for (let i = 1; i <= daysInMonth; i++) {
			const day = daysOfWeek[(startDay + i - 1) % 7] + '\n' + i;
			const formattedDate = `${String(i).padStart(2, '0')}/${String(month).padStart(
				2,
				'0',
			)}/${year}`;

			datesArray.push(formattedDate);
			headers.push(day);
		}

		setDateArray(datesArray);

		const additionalHeaders = [
			'Total Present',
			'Total Absent',
			'Total Unmarked',
			'Total Working Hours',
		];

		headers.push(...additionalHeaders);

		return headers;
	}

	groupedById = tableData.reduce((acc, obj) => {
		const { employeeId } = obj; // Extract employeeId from the current object

		// If employeeId isn't already a key in the accumulator, initialize it as an empty array
		if (!acc[employeeId]) {
			acc[employeeId] = [];
		}

		// Push the current object into the array associated with its employeeId
		acc[employeeId].push(obj);

		return acc; // Return the updated accumulator
	}, {});
	for (const employeeId in groupedById) {
		const data = groupedById[employeeId];
		let totalPresent = 0;
		let totalUnmarked = 0;
		let totalWorkingHours = '00:00';
		for (const item of data) {
			if (item.status === 'present') {
				totalPresent++;
			}
			if (item.status === 'notMarked') {
				totalUnmarked++;
			}
			totalWorkingHours = addHHMMTime(
				totalWorkingHours,
				item.totalHours && formatEmpAttHours(item.totalHours),
			);
			// totalWorkingHours += item.totalHours && formatEmpAttHours(item.totalHours);
		}
		// Limit totalWorkingHours to 2 decimal places
		// totalWorkingHours = parseFloat(totalWorkingHours.toFixed(2));
		// Add metrics to summaryObj
		summaryObj[employeeId] = {
			totalPresent,
			totalUnmarked,
			totalWorkingHours,
		};
	}

	const groupedArray = Object.values(groupedById);

	console.log('hemlo', groupedById, 'hemlo', groupedArray);

	const convertHTMLTableToExcel = () => {
		const table = document.getElementById('myTable'); // Assume you have an HTML table with id 'myTable'

		// Convert HTML table to worksheet
		const ws = XLSX.utils.table_to_sheet(table);

		// Increase the width of all columns to 1.5 times their default width
		const defaultColWidth = 10; // default width (in units, where 1 unit is equivalent to the width of one character '0')
		const newColWidth = Math.floor(defaultColWidth * 1.5); // 1.5 times the default width

		// Check if the !cols property exists, if not, initialize it
		if (!ws['!cols']) {
			ws['!cols'] = [];
		}

		// Set the width for each column
		for (let colIndex = 0; colIndex < headers.length; colIndex++) {
			ws['!cols'][colIndex] = { wch: newColWidth }; // Setting width for each column in the worksheet
		}

		// Calculate the height for a rowSpan of 4 (assuming default row height is 19.5 pixels)
		const heightForRowSpanOf4 = 4 * 19.5;

		// Set the rowHeight for all rows starting from index 1 to the end
		for (let rowIndex = 1; rowIndex <= Object.keys(ws).length; rowIndex++) {
			ws['!rows'] = ws['!rows'] || [];
			ws['!rows'][rowIndex] = { hpx: heightForRowSpanOf4 };
		}

		// Convert content in column D (index 3 in zero-based index) to display data in different lines
		const colDIndex = 3; // This is the column index for column D (zero-based index)
		const typeOfDays = ['Attendance State', 'IN', 'OUT', 'WH']; // Your data

		// Loop through rows from D2 to the end
		for (let rowIndex = 1; rowIndex <= Object.keys(ws).length; rowIndex++) {
			const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colDIndex });
			const cell = ws[cellRef];

			if (cell && cell.v) {
				// Join typeOfDays array items with newline character and set the value of the cell
				cell.v = typeOfDays.join('\n');
				// Update the cell type to wrap text
				cell.t = 's'; // 's' means string type
				cell.s = {
					wrapText: true,
					border: {
						// Add border style here
						top: { style: 'thin', color: { rgb: 'FF000000' } },
						bottom: { style: 'thin', color: { rgb: 'FF000000' } },
						left: { style: 'thin', color: { rgb: 'FF000000' } },
						right: { style: 'thin', color: { rgb: 'FF000000' } },
					},
				}; // Set wrap text style and borders
			}
		}

		for (
			let rowIndex = 1, counter = 0;
			rowIndex <= Object.keys(ws).length, counter < groupedArray.length;
			rowIndex++, counter++
		) {
			for (let colIndex = 4; colIndex < numberOfDays + 4; colIndex++) {
				const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
				const cell = ws[cellRef];

				// Fetch the matchingItem for the current employeeId and date
				const currentEmployeeId = groupedArray[counter][0].employeeId; // Assuming tableData corresponds to ws rows
				const currentDate = dateArray[colIndex - 4]; // Adjusted index
				const matchingItem = groupedById[currentEmployeeId]?.find(
					(item) => item.date === currentDate,
				);

				console.log(
					'Hello',
					currentEmployeeId,
					'Hehe',
					currentDate,
					'Hello ji',
					matchingItem,
					'hoho',
					// tableData[rowIndex - 1],
					// counter,
					// groupedArray[counter][0],
					// groupedArray
				);

				if (cell && cell.v) {
					// Combine the values with a newline character
					let combinedValue = [
						matchingItem?.status === 'present'
							? 'P'
							: matchingItem?.status === 'notMarked'
							? 'Not Marked'
							: '-',
						matchingItem?.login || '-',
						matchingItem?.logout || '-',
						matchingItem?.totalHours &&
							(formatEmpAttHours(matchingItem.totalHours) || '-'),
					].join('\n');

					cell.v = combinedValue; // Set the combined value
					cell.t = 's'; // Set the cell type to string
					cell.s = {
						wrapText: true,
						border: {
							// Add border style here
							top: { style: 'thin', color: { rgb: 'FF000000' } },
							bottom: { style: 'thin', color: { rgb: 'FF000000' } },
							left: { style: 'thin', color: { rgb: 'FF000000' } },
							right: { style: 'thin', color: { rgb: 'FF000000' } },
						},
					}; // Set wrap text style and borders
				}
			}
		}

		for (let rowIndex = 1; rowIndex <= Object.keys(ws).length; rowIndex++) {
			const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: colDIndex });
			const cell = ws[cellRef];

			if (cell && cell.v) {
				// Join typeOfDays array items with newline character and set the value of the cell
				cell.v = typeOfDays.join('\n');
				// Update the cell type to wrap text
				cell.t = 's'; // 's' means string type
				cell.s = { wrapText: true }; // Set wrap text style
			}
		}

		for (let colIndex = 0; colIndex < headers.length; colIndex++) {
			const header = headers[colIndex];

			const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex }); // Row 0 is the first row where headers are populated
			const cell = ws[cellRef];

			if (cell) {
				// Set the header value including a newline character
				cell.v = header.replace('\n', '\r\n'); // Use \r\n for Windows-style line breaks

				// Enable text wrapping for the cell
				cell.s = {
					wrapText: true,
					border: {
						top: { style: 'thin', color: { rgb: 'FF000000' } },
						bottom: { style: 'thin', color: { rgb: 'FF000000' } },
						left: { style: 'thin', color: { rgb: 'FF000000' } },
						right: { style: 'thin', color: { rgb: 'FF000000' } },
					},
				};
			}
		}

		// Create a workbook
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		// Convert workbook to blob
		const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

		// Function to create download link and trigger download
		function s2ab(s) {
			const buf = new ArrayBuffer(s.length);
			const view = new Uint8Array(buf);
			for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
			return buf;
		}

		const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

		const selectedMonthName = new Date(data.selectedMonth);
		const monthNames = [
			'january',
			'february',
			'march',
			'april',
			'may',
			'june',
			'july',
			'august',
			'september',
			'october',
			'november',
			'december',
		];
		const monthName = monthNames[selectedMonthName.getMonth()];
		const workSpaceName = data.selectedworkspace;
		const departmentName = data.selectedDepartment || '';

		// Create download link
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `${workSpaceName}${departmentName && '_'}${departmentName}_${monthName}.xlsx`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);

		setdata((prev) => {
			return {
				...prev,
				selectedworkspace: '',
				selectedDepartment: '',
			};
		});
		modalState(false);
	};
	const getAttendance = async () => {
		setLoader(true);
		let usertoken = localStorage.getItem('usertoken');
		const response = await service.query(
			downloadAttendanceQuery,
			json,
			params?.vendorID,
			usertoken,
			'vendors',
		);
		if (response[0] === true) {
			localStorage.setItem(
				'tableData',
				JSON.stringify(response[1]?.data?.downloadEmpAttendance),
			);
			setDownloadAttendance(true);
			setLoader(false);
		}
	};
	const getUniqueTableData = (data) => {
		const uniqueData = [];
		const encounteredIds = new Set();

		for (const item of data) {
			if (!encounteredIds.has(item.employeeId)) {
				uniqueData.push(item);
				encounteredIds.add(item.employeeId);
			}
		}

		return uniqueData;
	};
	const uniqueTableData = getUniqueTableData(tableData);

	useEffect(() => {
		const getDepartmentAndWorkspace = async () => {
			try {
				const response = await requestExecutor(
					getDepartmentAndWorkspaceQuery,
					{},
					params.vendorID,
				);

				setdata((prev) => {
					return {
						...prev,
						workspaceOptions:
							response?.result?.employeeDefaultfilters?.workspaceId?.map((item) => ({
								label: item,
								value: item,
							})) || [],
						departmentOptions:
							response?.result?.employeeDefaultfilters?.department?.map((item) => ({
								label: item,
								value: item,
							})) || [],
					};
				});
			} catch (error) {
				console.log(error);
			}
		};

		getDepartmentAndWorkspace();
	}, []);
	useEffect(() => {
		const currentDate = new Date();
		const currentMonth = currentDate.getMonth() + 1;
		const currentYear = currentDate.getFullYear();

		// Convert the startDate to a string
		const startDateString = data.startDate.toString();

		// Extract the year and month portions from the startDateString
		const extractedYear = parseInt(startDateString.substring(0, 4));
		const extractedMonth = parseInt(startDateString.substring(4, 6));
		const generatedHeaders = generateHeaders(extractedMonth, extractedYear);

		console.log(data.startDate, data.endDate, extractedMonth, extractedYear, 'hello');
		setHeaders(generatedHeaders);

		return () => {
			localStorage.setItem('tableData', JSON.stringify([]));
		};
	}, [data.selectedMonth]);
	useEffect(() => {
		if (downloadAttendance === true) {
			convertHTMLTableToExcel();
			setDownloadAttendance(false);
		}
	}, [downloadAttendance]);

	return (
		<div>
			<div style={{ display: 'flex', gap: '10px', marginBottom: '1rem' }}>
				<button
					style={{
						height: '2.5rem',
						backgroundColor: '#6054EC',
						color: '#ffffff',
						cursor: 'pointer',
						borderRadius: '8px',
						width: '10rem',
						border: 'none',
					}}
					onClick={() => modalState(true)}
				>
					Download Attendance
				</button>
			</div>
			<Modal
				handleClose={() => {
					modalState(false);
					window.location.reload();
				}}
				show={isModalOpen}
				modalType={'center'}
			>
				<div
					className="mc-record-center-modal2"
					style={{
						minHeight: '430px',
						width: '640px',
					}}
				>
					<div className="mc-record-header">
						<span className="header-title">Download Attendance</span>
						<span
							className="header-more-icn"
							onClick={() => {
								modalState(false);
								window.location.reload();
							}}
						>
							<Cancel />
						</span>
					</div>

					<div
						style={{
							padding: '24px',
							maxHeight: '60vh',
							overflowY: 'auto',
							width: '100%',
						}}
					>
						<div style={{ marginBottom: '16px' }}>
							<label
								style={{
									color: '#B0B0B0',
									fontSize: '13px',
									fontStyle: 'normal',
									fontWeight: '400',
									lineHeight: '16px',
									letterSpacing: '-0.3px',
								}}
							>
								Workspace *
							</label>
							<br />
							<Select
								className="cost-select-container"
								classNamePrefix="cost-select"
								options={data.workspaceOptions}
								onChange={(e) => {
									setdata((prev) => ({
										...prev,
										selectedworkspace: e.value,
									}));
								}}
							/>
						</div>

						<div style={{ marginBottom: '16px' }}>
							<label
								style={{
									color: '#B0B0B0',
									fontSize: '13px',
									fontStyle: 'normal',
									fontWeight: '400',
									lineHeight: '16px',
									letterSpacing: '-0.3px',
								}}
							>
								Department
							</label>
							<br />
							<Select
								className="cost-select-container"
								classNamePrefix="cost-select"
								options={data.departmentOptions}
								onChange={(e) => {
									setdata((prev) => ({
										...prev,
										selectedDepartment: e.value,
									}));
								}}
							/>
						</div>

						<div style={{ marginBottom: '16px' }}>
							<label
								style={{
									color: '#B0B0B0',
									fontSize: '13px',
									fontStyle: 'normal',
									fontWeight: '400',
									lineHeight: '16px',
									letterSpacing: '-0.3px',
								}}
							>
								Select Month *
							</label>
							<div className="dp-container">
								<DatePicker
									showPopperArrow={false}
									popperClassName={'datepicker3-popper'}
									ref={calRef}
									selected={data.selectedMonth}
									onChange={(date) => {
										const year = date.getFullYear();
										const month = date.getMonth();

										const formattedStartDate = parseInt(
											`${year}${String(month + 1).padStart(2, '0')}01`,
											10,
										);
										const formattedEndDate = parseInt(
											`${year}${String(month + 1).padStart(2, '0')}${new Date(
												year,
												month + 1,
												0,
											).getDate()}`,
											10,
										);
										setdata((prev) => ({
											...prev,
											selectedMonth: date,
											startDate: formattedStartDate,
											endDate: formattedEndDate,
										}));
									}}
									showMonthYearPicker
									dateFormat="MM/yyyy"
								/>
							</div>
						</div>

						{data.selectedworkspace && data.selectedMonth && (
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									paddingTop: '8px',
								}}
							>
								<div className="create-shoot-btn" onClick={getAttendance}>
									{loader === true ? 'Fetching...' : 'Generate Attendance'}
								</div>
							</div>
						)}
					</div>
				</div>
			</Modal>
			<table style={{ borderCollapse: 'collapse', display: 'none' }} id="myTable">
				<thead>
					<tr>
						{headers.map((header, index) => (
							<th key={index} style={{ border: '1px solid black', padding: '8px' }}>
								<div>{header.split('\n')[0]}</div>
								<div>{header.split('\n')[1]}</div>
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{uniqueTableData?.map((tableElement, index) => (
						<tr key={tableElement.employeeId}>
							<td style={{ border: '1px solid black', padding: '8px' }}>
								{index + 1}
							</td>
							<td style={{ border: '1px solid black', padding: '8px' }}>
								{tableElement.fullName}
							</td>
							<td style={{ border: '1px solid black', padding: '8px' }}>
								{tableElement.department ? tableElement.department : '-'}
							</td>
							{/* Render the days */}
							<td>
								{typeOfDays.map((day, dayIndex) => (
									<td
										style={{
											border: '1px solid black',
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										{day}
									</td>
								))}
							</td>
							{/* Render attendance state, login, logout, working Hours times */}
							{dateArray.map((date, idx) => {
								// Check if the item contains a date that matches the current date from dateArray
								const matchingItem = groupedById[tableElement.employeeId]?.find(
									(item) => item.date === date,
								);

								return (
									<>
										<td
											key={idx}
											style={{
												border: '1px solid black',
												padding: '8px',
											}}
										>
											{[
												matchingItem && matchingItem.status === 'present'
													? 'P'
													: matchingItem &&
													  matchingItem.status === 'notMarked'
													? 'Not Marked'
													: null,
												matchingItem && matchingItem.login,
												matchingItem && matchingItem.logout,
												matchingItem &&
													matchingItem.totalHours &&
													formatEmpAttHours(matchingItem.totalHours),
											].map((item, index) => (
												<div key={index}>
													{index !== 0 && '\n'}{' '}
													{/* Only show '\n' for items after the first one */}
													{item || '-'}
												</div>
											))}
										</td>
									</>
								);
							})}

							<td style={{ border: '1px solid black', padding: '8px' }}>
								{summaryObj[tableElement.employeeId].totalPresent}
							</td>
							<td style={{ border: '1px solid black', padding: '8px' }}>{0}</td>
							<td style={{ border: '1px solid black', padding: '8px' }}>
								{summaryObj[tableElement.employeeId].totalUnmarked}
							</td>
							<td style={{ border: '1px solid black', padding: '8px' }}>
								{summaryObj[tableElement.employeeId].totalWorkingHours &&
									formatEmpAttHours(
										summaryObj[tableElement.employeeId].totalWorkingHours,
									)}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default AttendanceFormatTable;
